// AnalyticsProvider (issue #343 / ADR-0011) — the client-side capture hook-up.
//
// Headless: mounted in the root provider stack (routes/root.tsx), inside the
// Router so `useLocation()` resolves. It starts the buffered analytics client
// and fires a `page_view` on every pathname change — the only reliable page-view
// signal in this CSR / React-Router-v7 app, which has no global router listener.
// Mounted for STAFF only (the portal is out of scope for Phase 1).

import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { startAnalytics, stopAnalytics, trackPageView } from '@/lib/analytics/client';

export function AnalyticsProvider() {
    const { pathname } = useLocation();

    useEffect(() => {
        startAnalytics();
        return () => stopAnalytics();
    }, []);

    useEffect(() => {
        trackPageView(pathname);
    }, [pathname]);

    return null;
}
